import React, {useContext} from "react";
import AuthenticationService from "@services/AuthenticationService";
import MenuIcon from "@ui-components/AppNavigation/MenuIcon";
import UserNotificationsContext from "../../UserNotificationsContext";
import {BellSlashIcon} from "@heroicons/react/24/outline";
import Button from "@ui-components/Button";
import {FormattedMessage} from "react-intl";

const NotificationsBox = ({
  slim=false,
  onClick=undefined,
}) => {

  // context
  const { userNotifications } = useContext(UserNotificationsContext);

  // utilities
  const { role_type: userRole } = AuthenticationService.getUserData();

  if (userRole !== "admin" || !userNotifications?.length)
    return null;

  if (slim)
    return <MenuIcon name="Notification-Disabled" size={25} onClick={onClick} hover />

  return (
    <div className="w-full mb-2">
      <Button
        full
        styleType="white"
        paddingCls="px-2 py-1"
        onClick={onClick}
      >
        <BellSlashIcon className="w-4" />
        <span style={{ fontSize: "0.575rem" }}>
          <FormattedMessage id="mark_notifications_as_read" />
        </span>
      </Button>
    </div>
  )
}

export default NotificationsBox;